import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PayrollMenu from "./PayrollMenu.js";
import moment from "moment";
import Pagination from "../General/Pagination";
import MonthsDropDown from "../Shared/MonthsDropDown.js";
import YearsDropDown from "../Shared/YearsDropDown.js";
import EmployeeTypeDropDown from "../Shared/EmployeeTypeDropDown";
import EmployeeCampusDropDown from "../Shared/EmployeeCampusDropDown";
import DesignationDropDown from "../Shared/DesignationDropDown";
//import { exportCSV } from 'csv-export';
import csvDownload from "json-to-csv-export";
import SalaryTypeDropDown from "../Shared/SalaryTypeDropDown.js";
import { Form } from "react-bootstrap";

const PayrollReport = (props) => {
    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(
        localStorage.getItem("MemberType")
    );
    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [isUpdated, setIsUpdated] = useState(false);
    const [selectedYear, setSelectedYear] = useState(moment().format("YYYY"));
    const [selectedMonth, setSelectedMonth] = useState(moment().format("M"));
    const [Deductions, setDeductions] = useState(false);
    const [EmployeeType, setEmployeeType] = useState(0);
    const [TotalDeductions, setTotalDeductions] = useState(0);
    const [TotalGross, setTotalGross] = useState(0);
    const [TotalNet, setTotalNet] = useState(0);
    const [OrderBy, setOrderBy] = useState("Code");
    const [ShowList, setShowList] = useState("All");
    const [loaddata, setLoaddata] = useState(false);
    const [CampusID, setCampusID] = useState(0);
    const [Designation_ID, setDesignation_ID] = useState(0);
    const [Department_ID, setDepartment_ID] = useState(0);
    const [salaryTypeID, setSalaryTypeID] = useState(0);
    const [Code, setCode] = useState("");
    const [validated, setValidated] = useState(false);

    // pagination
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [totalRecords, setTotalRecords] = useState(0);
    const [ledgerRecord, setLedgerRecord] = useState([]);
    const roundAmount = (value) => Math.round(Number(value || 0));

    useEffect(() => {
        document.title = "Payroll Report";

        setIsUpdated(false);
        setLoading(true);

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            pageNo: pageNo,
            pageSize: pageSize,
            SchoolID: 1,
            SelectedMonth: selectedMonth,
            FYear: selectedYear,
            EmployeeTypeId: EmployeeType,
            OrderBy: OrderBy,
            Loans: false,
            Deduction: Deductions,
            ShowList: ShowList,
            NewPassword: Code,
            Class_Id: salaryTypeID,
            Section_Id: Designation_ID,
            LateFineAmount: CampusID,
            NewClass_Id: Department_ID,
        };
        ////console.log(data);

        var api_config = {
            method: "post",
            url: config.base_url + "Payroll/GetPayrollReport",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(api_config)
            .then(function (response) {
                // console.log(response.data);
                if (response.data.status_code == 1) {
                    setLedger(response.data.ListofRecords);
                    setTotalRecords(response.data.totalRecords);
                    setTotalDeductions(response.data.TotalDeductions);
                    setTotalGross(response.data.TotalGross);
                    setTotalNet(response.data.TotalNet);
                    setLoading(false);
                } else {
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setLoading(false);
                }
            })
            .catch(function (error) {
                //console.log(error);
            });
    }, [
        pageNo,
        pageSize,
        isUpdated,
        Deductions,
        selectedMonth,
        selectedYear,
        EmployeeType,
        OrderBy,
        ShowList,
        CampusID,
        Designation_ID,
        Department_ID,
        salaryTypeID,
    ]);

    const handlePageChange = (page) => {
        setPageNo(page);
    };

    const renderLedger = () => {
        if (listOfLedger != null && listOfLedger.length > 0) {
            let count = 1;
            return listOfLedger.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{count++ + pageSize * (pageNo - 1)}</td>
                        <td>{item.OldSerialNo}</td>
                        <td>{item.Code}</td>
                        <td>{item.Name}</td>
                        <td>{item.Account_No}</td>
                        <td>{item.Father_Name}</td>
                        <td>{item.Department}</td>
                        <td>{item.DeductionText}</td>
                        <td>{moment(item.Date_Of_Joining).format("DD/MM/YYYY")}</td>
                        <td>{roundAmount(item.TotalSalary)}</td>
                        <td>{roundAmount(item.Deductions)}</td>
                        <td>{roundAmount(item.TotalSalary - item.Deductions)}</td>
                        {/* <td>{Math.round(item.DeductionFlag)}</td> */}
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="12">
                        <h4
                            className="mt-3"
                            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
                        >
                            No Data Found
                        </h4>
                    </td>
                </tr>
            );
        }
    };


    const handleDownload = () => {
        setLoaddata(true);

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            pageNo: 1,
            pageSize: 1000000,
            SchoolID: 1,
            SelectedMonth: selectedMonth,
            FYear: selectedYear,
            EmployeeTypeId: EmployeeType,
            OrderBy: OrderBy,
            Loans: false,
            Deduction: Deductions,
            ShowList: ShowList,
            NewPassword: Code,
            Class_Id: salaryTypeID,
            Section_Id: Designation_ID,
            LateFineAmount: CampusID,
            NewClass_Id: Department_ID,
        };
        //console.log(data);

        var api_config = {
            method: "post",
            url: config.base_url + "Payroll/GetPayrollReport",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(api_config)
            .then(function (response) {
                //console.log(response.data);
                if (response.data.status_code == 1) {
                    if (response.data.totalRecords > 0) {
                        setLedgerRecord(response.data.ListofRecords);
                        const salaryList = response.data.ListofRecords;
                        let count = 1;
                        const listOfLedgerNew = salaryList.map(({ ...rest }) => ({
                            Serial_No: count++ + pageSize * (pageNo - 1),
                            ID: rest.OldSerialNo,
                            Code: rest.Code,
                            Name: rest.Name,
                            Account_No: rest.Account_No,
                            Campus: rest.Father_Name,
                            Department: rest.Department,
                            Designation: rest.DeductionText,
                            DOJ: moment(rest.Date_Of_Joining).format("DD/MM/YYYY"),
                            "Gross Salary": roundAmount(rest.TotalSalary),
                            "Total Deductions": roundAmount(rest.Deductions),
                            "Net Salary": roundAmount(rest.TotalSalary - rest.Deductions),
                        })
                        );
                        //console.log('new', listOfLedgerNew);

                        const dataToConvert = {
                            data: listOfLedgerNew,
                            filename: "BankSalaryList",
                            delimiter: ",",
                            headers: [
                                "Serial_No",
                                "Employee ID",
                                "Code",
                                "Name",
                                "Account No",
                                "Campus",
                                "Department",
                                "Designation",
                                "DOJ",
                                "Gross Salary",
                                "Total Deductions",
                                "Net Salary"
                            ],
                        };
                        csvDownload(dataToConvert);

                        setLoaddata(false);
                    } else if (response.data.totalRecords === 0) {
                        toast.error("There is no data available for download", {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        setLoaddata(false);
                    }
                } else {
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setLoaddata(false);
                }
            })
            .catch(function (error) {
                toast.error("Network Error..", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setLoaddata(false);
            });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsUpdated(true);
        setLoading(true);

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            pageNo: pageNo,
            pageSize: pageSize,
            SchoolID: 1,
            SelectedMonth: selectedMonth,
            FYear: selectedYear,
            EmployeeTypeId: EmployeeType,
            OrderBy: OrderBy,
            Loans: false,
            Deduction: Deductions,
            ShowList: ShowList,
            NewPassword: Code,
            Class_Id: salaryTypeID,
            Section_Id: Designation_ID,
            LateFineAmount: CampusID,
            NewClass_Id: Department_ID,
        };
        ////console.log(data);

        var api_config = {
            method: "post",
            url: config.base_url + "Payroll/GetPayrollReport",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(api_config)
            .then(function (response) {
                // console.log(response.data);
                if (response.data.status_code == 1) {
                    setLedger(response.data.ListofRecords);
                    setTotalRecords(response.data.totalRecords);
                    setTotalDeductions(response.data.TotalDeductions);
                    setTotalGross(response.data.TotalGross);
                    setTotalNet(response.data.TotalNet);
                    setLoading(false);
                } else {
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setLoading(false);
                }
            })
            .catch(function (error) {
                //console.log(error);
            });
    }


    return (
        <>
            <PayrollMenu />
            <ToastContainer />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/Dashboard">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/PayRoll/PayRollDashboard">PayRoll</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Payroll Report
                                    </li>
                                </ol>
                            </nav>
                            <div className="page-title">Payroll Report</div>
                        </div>
                        <div className="col-md-6">
                            <div className="page-right-actions">
                                <Link
                                    to="javascript:;"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseFilteres"
                                    className="button button-white button-icon"
                                >
                                    Show Filters
                                    <i className="ri-filter-3-line"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="collapse show" id="collapseFilteres">
                <div className="container">
                    <div className="card mb-3">
                        <div className="card-body p-md-3">
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <div className="row align-items-center gy-3">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Select Month</label>
                                            <select
                                                className="form-select"
                                                required=""
                                                value={selectedMonth}
                                                onChange={(e) => setSelectedMonth(e.target.value)}
                                            >
                                                <MonthsDropDown />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Select Year</label>
                                            <select
                                                className="form-select"
                                                value={selectedYear}
                                                onChange={(e) => setSelectedYear(e.target.value)}
                                                required=""
                                            >
                                                <YearsDropDown />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Show LIst</label>
                                            <select
                                                className="form-select"
                                                required=""
                                                onChange={(e) => setShowList(e.target.value)}
                                            >
                                                <option value="All">All</option>
                                                <option value="HaveAccount">Have Account No</option>
                                                <option value="NoAccountNo">No Account</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Salary Type</label>
                                            <select
                                                className="form-select"
                                                required=""
                                                onChange={(e) => setSalaryTypeID(e.target.value)}
                                            >
                                                <option value="0">Please Select</option>
                                                <SalaryTypeDropDown />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Campus</label>
                                            <select
                                                className="form-select"
                                                required=""
                                                onChange={(e) => setCampusID(e.target.value)}
                                            >
                                                <option value="0">Please Select</option>
                                                <EmployeeCampusDropDown />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Department</label>
                                            <select
                                                className="form-select"
                                                required=""
                                                onChange={(e) => setDepartment_ID(e.target.value)}
                                            >
                                                <option value="0">Please Select</option>
                                                <EmployeeTypeDropDown />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Designation</label>
                                            <select
                                                className="form-select"
                                                required=""
                                                onChange={(e) => setDesignation_ID(e.target.value)}
                                            >
                                                <option value="0">Please Select</option>
                                                <DesignationDropDown />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Code</label>
                                            <input type="text" name="Code" className="form-control"
                                                onChange={(e) => setCode(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label className="">
                                                Print Without :
                                            </label>
                                            <div className="d-flex justify-content-between">
                                                <div className="form-check">
                                                    <label htmlFor="ChkDeduction">Deductions</label>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="ChkDeduction"
                                                        checked={Deductions}
                                                        onChange={(e) => setDeductions(e.target.checked)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2 offset-md-7">
                                        <input
                                            type="submit"
                                            value="Search"
                                            className="button button-primary w-100"
                                        />
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <div className="container">
                    <div className="card">
                        <div className="card-body">
                            <table className="table table-theme table-hover">
                                <thead>
                                    <tr>
                                        <th>Sr. No</th>
                                        <th>Employee ID</th>
                                        <th>Code</th>
                                        <th>Staff Name</th>
                                        <th>Account No</th>
                                        <th>Campus</th>
                                        <th>Department</th>
                                        <th>Designation</th>
                                        <th>DOJ</th>
                                        <th>Gross Salary</th>
                                        <th>Total Deductions</th>
                                        <th>Net Salary</th>
                                        {/* <th></th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td className="text-center" colSpan="12">
                                                <Spinner animation="border" role="status"></Spinner>
                                            </td>
                                        </tr>
                                    ) : (
                                        <>{renderLedger()}</>
                                    )}
                                    <tr>
                                        <td colSpan={9}></td>
                                        <td>{roundAmount(TotalGross)}</td>
                                        <td>{roundAmount(TotalDeductions)}</td>
                                        <td>{roundAmount(TotalNet)}</td>
                                        {/* <td></td> */}
                                    </tr>
                                </tbody>
                            </table>
                            {totalRecords > 10 && (
                                <div className="pagination-wrap">
                                    <div className="row align-items-center">
                                        <div className="col-md-2 form_default">
                                            <div className="d-flex align-items-center">
                                                <label className="me-2" style={{ fontSize: "15px" }}>
                                                    Page Size
                                                </label>
                                                <div className="form-group">
                                                    <select
                                                        className="form-select"
                                                        style={{ width: "100px" }}
                                                        onChange={(e) => {
                                                            setPageNo(1);
                                                            setPageSize(parseInt(e.target.value));
                                                        }}
                                                    >
                                                        <option value="10">10</option>
                                                        <option value="20">20</option>
                                                        <option value="50">50</option>
                                                        <option value="100" selected>
                                                            100
                                                        </option>
                                                        <option value="500">500</option>
                                                        <option value="1000">1000</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <Pagination
                                            pageNo={pageNo}
                                            pageSize={pageSize}
                                            totalRecords={totalRecords}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="card mt-md-3">
                        <div className="card-body">
                            <div className="row justify-content-end">
                                <div className="col-md-2">
                                    <NavLink
                                        target="_blank"
                                        to={`/PayRoll/PrintBankSalalryList/?month=${selectedMonth}&year=${selectedYear}&OrderBy=${OrderBy}&ShowList=${ShowList}&Department=${Department_ID}&loans=false&Deductions=${Deductions}`}
                                        className="button button-primary w-100"
                                    >
                                        Print This Report
                                    </NavLink>
                                </div>
                                {loaddata ?
                                    <div className="col-md-2 ">
                                        <div className="text-center" >
                                            <Spinner animation="border" role="status"></Spinner>
                                        </div>
                                    </div>

                                    : <div className="col-md-2">
                                        <button
                                            type="button"
                                            onClick={handleDownload}
                                            className="button button-primary w-100"
                                        >
                                            Download File
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PayrollReport;